// extracted by mini-css-extract-plugin
export default {"GateBody":"jsonParse_GateBody__H9Q9u","WidgetDisabled":"jsonParse_WidgetDisabled__TilvQ"};